module.exports = __webpack_public_path__ + "static/granulat_sloik@0,5x-c06c011779a542a964796e20accf66bd.png";